import { cssToken } from '@youhelp-ru/ui';

export const name = 'Dialog';

/**
 * Parent container width to render desktop layout
 */
export const DESKTOP_LAYOUT_WIDTH = '600px';
export const Tokens = {
  gap: cssToken(name, ['gap']),
  maxWidth: cssToken(name, 'maxWidth'),
  /**
   * Gap between elements of message list
   */
  listGap: cssToken(name, ['dimension', 'list', 'gap']),
  headerGap: cssToken(name, ['dimension', 'header', 'gap']),
  listBackground: cssToken(name, ['color', 'list', 'background']),
  colorPaper: cssToken(name, ['color', 'paper']),
  colorBorder: cssToken(name, ['color', 'border']),
  blockHeaderLine: cssToken(name, ['color', 'header', 'line']),
  blockHeaderText: cssToken(name, ['color', 'header', 'text']),
  authorNameText: cssToken(name, ['color', 'author']),
  authorNameDisplay: cssToken(name, ['display', 'author']),
};
